import { render } from "./ComingSoon.vue?vue&type=template&id=38f87f88&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=38f87f88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38f87f88"

export default script